import { gql } from "gql";

export const GET_POST_TO_EDIT = gql(/* GraphQL */ `
  query GetPostToEdit($id: ID!) {
    getPostById(id: $id) {
      id
      title
      body
      media {
        id
      }
    }
  }
`);
